import { AfterViewInit, Component, ElementRef, forwardRef, Inject, Input, PLATFORM_ID, Renderer2, Optional } from '@angular/core';
import { ControlValueAccessor, NG_VALIDATORS, NG_VALUE_ACCESSOR } from '@angular/forms';
import { DOCUMENT } from '@angular/common';
import { UploadComponent as TmUploadComponent, UPLOAD_ASSETS } from '@techmore/upload';
import { isNullOrUndefined } from 'util';
import { AppUploadFile, NewUploadSetting } from 'src/app/share/entity/upload-file';
import { UploadService } from 'src/app/share/service/upload.service';

@Component({
  selector: 'app-img-upload',
  templateUrl: './img-upload.component.html',
  styleUrls: ['./img-upload.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ImgUploadComponent),
      multi: true
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => ImgUploadComponent),
      multi: true,
    }
  ]
})
export class ImgUploadComponent extends TmUploadComponent implements AfterViewInit, ControlValueAccessor {
  files: Array<AppUploadFile> = [];
  @Input() uploadSetting: NewUploadSetting;

  constructor(
    protected el: ElementRef,
    @Inject(PLATFORM_ID) protected platformId: any,
    @Inject(DOCUMENT) protected document: any,
    @Optional() @Inject(UPLOAD_ASSETS) protected assets: any,
    protected render: Renderer2,
    protected uploadService: UploadService,
  ) {
    super(el, platformId, document, assets, render);

    this.upload2Serv = this.uploadService.uploadFile2Server;
  }

  /**
   * 檔案上傳到服務器完畢
   * @param file 上傳的檔案
   */
  onUploadFinish(file: AppUploadFile, uploadFeedBack: any) {
    Object.assign(file, uploadFeedBack);
    file['otherInfos'] = uploadFeedBack.otherInfos || {};
    this.sortFiles();
    this.propagateChange(this.files);
    this.triggerDomChangeEvent();
    this.onUploadFinsihed();
  }

  ngOnInit(): void {
    super.ngOnInit();
    
    this.uploadService.getUploadSetting(this.type)
    .subscribe(val => {
      this.uploadSetting = val;
    });
  }

  checkExt(ext: string): boolean {
    if (isNullOrUndefined(ext)) {
      return false;
    }
    if (this.uploadSetting.ext.length === 0) {
      return true;
    }

    return this.uploadSetting.ext.findIndex((val) => ext.toLocaleLowerCase() === val.toLocaleLowerCase()) >= 0;
  }

  checkSize(size: number): boolean {
    if (isNullOrUndefined(size)) {
      return false;
    }

    return this.uploadSetting.byte >= size;
  }
}
